<script>
    export let svgClr = 'white';
    export let backClr = 'black';
</script>

<section>
    <div class="footer" style="background-color: {backClr};">
        <div class="icons-div">
            <a href="https://www.linkedin.com/company/opusai/"
            target="__blank"
            >
                <div class="linkdin">
                    <svg
                        width="100%"
                        height="100%"
                        viewBox="0 0 24 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M21.3063 0H1.69875C0.759493 0 0 0.741211 0 1.65762V21.3379C0 22.2543 0.759493 23 1.69875 23H21.3063C22.2455 23 23.0095 22.2543 23.0095 21.3424V1.65762C23.0095 0.741211 22.2455 0 21.3063 0ZM6.82645 19.5994H3.41098V8.62051H6.82645V19.5994ZM5.11872 7.12461C4.02217 7.12461 3.13684 6.23965 3.13684 5.14805C3.13684 4.05645 4.02217 3.17148 5.11872 3.17148C6.21077 3.17148 7.09609 4.05645 7.09609 5.14805C7.09609 6.23516 6.21077 7.12461 5.11872 7.12461ZM19.6075 19.5994H16.1965V14.2627C16.1965 12.9914 16.1741 11.3518 14.4214 11.3518C12.6462 11.3518 12.3766 12.7398 12.3766 14.1729V19.5994H8.97011V8.62051H12.2418V10.1209H12.2867C12.7406 9.2584 13.8551 8.34648 15.5134 8.34648C18.9694 8.34648 19.6075 10.6195 19.6075 13.5754V19.5994Z"
                            fill={svgClr}
                        />
                    </svg>
                </div>
            </a>
            <a href="https://discord.gg/mEWEUkTFHh"
            target="__blank"
            >
                <div class="discord">
                    <svg
                        width="100%"
                        height="100%"
                        viewBox="0 0 22 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.72369 10.4863C8.00712 10.4863 7.44141 11.1113 7.44141 11.8738C7.44141 12.6363 8.01969 13.2613 8.72369 13.2613C9.44026 13.2613 10.006 12.6363 10.006 11.8738C10.0185 11.1113 9.44026 10.4863 8.72369 10.4863ZM13.3123 10.4863C12.5957 10.4863 12.03 11.1113 12.03 11.8738C12.03 12.6363 12.6083 13.2613 13.3123 13.2613C14.0288 13.2613 14.5946 12.6363 14.5946 11.8738C14.5946 11.1113 14.0288 10.4863 13.3123 10.4863Z"
                            fill={svgClr}
                        />
                        <path
                            d="M19.4229 0H2.57714C1.15657 0 0 1.15 0 2.575V19.475C0 20.9 1.15657 22.05 2.57714 22.05H16.8331L16.1669 19.7375L17.776 21.225L19.2971 22.625L22 25V2.575C22 1.15 20.8434 0 19.4229 0ZM14.5703 16.325C14.5703 16.325 14.1177 15.7875 13.7406 15.3125C15.3874 14.85 16.016 13.825 16.016 13.825C15.5006 14.1625 15.0103 14.4 14.5703 14.5625C13.9417 14.825 13.3383 15 12.7474 15.1C11.5406 15.325 10.4343 15.2625 9.49143 15.0875C8.77486 14.95 8.15886 14.75 7.64343 14.55C7.35429 14.4375 7.04 14.3 6.72571 14.125C6.688 14.1 6.65029 14.0875 6.61257 14.0625C6.58743 14.05 6.57486 14.0375 6.56229 14.025C6.336 13.9 6.21029 13.8125 6.21029 13.8125C6.21029 13.8125 6.81371 14.8125 8.41029 15.2875C8.03314 15.7625 7.568 16.325 7.568 16.325C4.78971 16.2375 3.73371 14.425 3.73371 14.425C3.73371 10.4 5.544 7.1375 5.544 7.1375C7.35429 5.7875 9.07657 5.825 9.07657 5.825L9.20229 5.975C6.93943 6.625 5.896 7.6125 5.896 7.6125C5.896 7.6125 6.17257 7.4625 6.63771 7.25C7.98286 6.6625 9.05143 6.5 9.49143 6.4625C9.56686 6.45 9.62971 6.4375 9.70514 6.4375C10.472 6.3375 11.3394 6.3125 12.2446 6.4125C13.4389 6.55 14.7211 6.9 16.0286 7.6125C16.0286 7.6125 15.0354 6.675 12.8983 6.025L13.0743 5.825C13.0743 5.825 14.7966 5.7875 16.6069 7.1375C16.6069 7.1375 18.4171 10.4 18.4171 14.425C18.4171 14.425 17.3486 16.2375 14.5703 16.325Z"
                            fill={svgClr}
                        />
                    </svg>
                </div>
            </a>
            <a href="https://twitter.com/OpusAIInc"
            target="__blank"
            >
                <div class="twitter">
                    <svg
                        width="100%"
                        height="100%"
                        viewBox="0 0 26 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.17934 20C17.9882 20 23.3548 12.3046 23.3548 5.63322C23.3548 5.41688 23.3497 5.19574 23.3396 4.9794C24.3835 4.26466 25.2845 3.37935 26 2.36507C25.0277 2.7746 23.9954 3.04206 22.9384 3.15831C24.0514 2.52672 24.8847 1.53451 25.284 0.365627C24.2369 0.953083 23.0919 1.36748 21.8979 1.59106C21.0934 0.78181 20.0297 0.24599 18.8713 0.0664421C17.7129 -0.113105 16.5243 0.0736207 15.4892 0.597751C14.4541 1.12188 13.6303 1.95422 13.145 2.96609C12.6597 3.97796 12.54 5.11299 12.8045 6.1957C10.6844 6.09498 8.61026 5.57358 6.71665 4.6653C4.82303 3.75702 3.15217 2.48213 1.81238 0.923299C1.13143 2.03477 0.923061 3.35001 1.22962 4.6017C1.53617 5.85339 2.33465 6.94762 3.46277 7.66199C2.61585 7.63654 1.78747 7.42066 1.04609 7.03221V7.09471C1.04534 8.26111 1.47127 9.39178 2.2515 10.2945C3.03173 11.1972 4.1181 11.8163 5.32594 12.0464C4.54139 12.2497 3.71798 12.2793 2.91941 12.133C3.26024 13.1361 3.92337 14.0135 4.81625 14.6426C5.70913 15.2718 6.78721 15.6213 7.90004 15.6425C6.01079 17.0474 3.67702 17.8095 1.27461 17.8058C0.848561 17.8052 0.422932 17.7805 0 17.7318C2.44059 19.2141 5.27966 20.0014 8.17934 20Z"
                            fill={svgClr}
                        />
                    </svg>
                </div>
            </a>
        </div>
    </div>
</section>

<style>
    .footer {
        width: 100%;
        height: 12.85vw;
        border-radius: 2.336vw 2.336vw 0px 0px;
    }
    .icons-div {
        display: flex;
        height: 100%;
        width: 40.888vw;
        justify-content: space-between;
        align-items: center;
        margin: auto;
    }
    .linkdin {
        width: 5.374vw;
        height: 5.374vw;
    }
    .twitter {
        width: 6.075vw;
        height: 4.673vw;
    }
    .discord {
        width: 5.14vw;
        height: 5.841vw;
    }
</style>
